import React, { useEffect } from 'react';
import { useBooking } from '../context/BookingContext';

const WidgetLoader = () => {
    const { dispatch } = useBooking();
    
    useEffect(() => {
        // This is just a backup - initial state should have handled it
        const searchParams = new URLSearchParams(window.location.search);
        const fromWidget = searchParams.get('from_widget');
        
        if (fromWidget === 'true') {
            console.log('📝 WidgetLoader: Setting auto-search flag');
            
            // Set flag for auto-search in RoomSelection
            sessionStorage.setItem('shouldAutoSearch', 'true');
            
            // Clean URL
            if (window.history.replaceState) {
                const cleanUrl = window.location.pathname;
                window.history.replaceState({}, document.title, cleanUrl);
                console.log('🧹 WidgetLoader cleaned URL');
            }
        }
    }, [dispatch]);
    
    return null;
};

export default WidgetLoader;